export default __webpack_public_path__ + "faf4431e4de5548fd55b78109fbf17f1.coffee";